import React from 'react';
import ReactDOM from 'react-dom';
import {
  BrowserRouter as Router,
  Routes,
  Route
} from "react-router-dom";
import './index.css';
import App from './App';
import Leader from './Leader';
import reportWebVitals from './reportWebVitals';
const mission = "holidays2021"
ReactDOM.render(
  <React.StrictMode>
    <Router>
      <Routes>
        <Route path="/leader" element={ <Leader mission={mission}/> }/>
        <Route path="/*" caseSensitive={false} element={ <App mission={mission}/> } />
      </Routes>
    </Router>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
